import axiosInstance from './axios';

export const clothingService = {
  getItems: () => axiosInstance.get('/api/clothing'),
  createItem: (data) => axiosInstance.post('/api/clothing', data),
  updateItem: (id, data) => axiosInstance.put(`/api/clothing/${id}`, data),
  deleteItem: (id) => axiosInstance.delete(`/api/clothing/${id}`),
  recordWear: (id) => axiosInstance.post(`/api/clothing/${id}/wear`),
  recordWash: (id) => axiosInstance.post(`/api/clothing/${id}/wash`)
};